
<mat-divider></mat-divider>

<div class="section-label">
  <div class="review_edit-area">
    <div *ngIf="reviewState === reviewStates.ReadOnly">
      <app-icon-button icon="edit" label="EDIT" (click)="editDetails()"></app-icon-button>
    </div>
    <div *ngIf="reviewState === reviewStates.Edit">
      <a mat-button target="_blank" class="buttonLink" (click)="save()">Save</a>
      <a mat-button target="_blank" class="buttonLink" (click)="cancel()">Cancel</a>
    </div>
  </div>
</div>

<form [formGroup]="bsaProfileForm" (ngSubmit)="onSubmit()">
  <fieldset>
    <h2 class="section-label">Account Details</h2>
    <div class="form-error" *ngIf="reviewState === reviewStates.ReadOnly && !bsaProfileForm.valid">
      This section requires attention. Please edit and review the account details accordingly.
    </div>
    <ng-container *ngIf="bsaDetails" class="subtitle-margin">
      <div class="detailsMessage">{{bsaDetails}}</div>
    </ng-container>
    <div fxLayout="row" fxLayout.xs="column" class="section">
      <div [fxFlex]="70">
        <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Will you be conducting ACH transactions?</div>
      </div>

      <div [fxFlex]="reviewState != reviewStates.ReadOnly ? '30' : '30'" class="options">
        <div *ngIf="reviewState != reviewStates.ReadOnly">
          <mat-radio-group id="achTransactions" class="profile-radio-group" formControlName="achTransactions">
            <mat-radio-button id="achTransactionsYes" [value]="true">Yes</mat-radio-button>
            <mat-radio-button id="achTransactionsNo" [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
          <mat-label class="read-only-label">{{getFormControlValue('achTransactions') ? 'Yes' : 'No'}}</mat-label>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayout.xs="column" class="section">
      <div [fxFlex]="70">
        <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Will you be conducting wire transactions domestically?</div>
      </div>

      <div [fxFlex]="reviewState != reviewStates.ReadOnly ? '30' : '30'" class="options">
        <div *ngIf="reviewState != reviewStates.ReadOnly">
          <mat-radio-group id="wireDomestic" class="profile-radio-group" formControlName="wireDomestic">
            <mat-radio-button id="wireDomesticYes" [value]="true">Yes</mat-radio-button>
            <mat-radio-button id="wireDomesticNo" [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
          <mat-label class="read-only-label">{{getFormControlValue('wireDomestic') ? 'Yes' : 'No'}}</mat-label>
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayout.xs="column" class="section">
      <div [fxFlex]="70">
        <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Will you be conducting wire transactions internationally?</div>
      </div>

      <div [fxFlex]="reviewState != reviewStates.ReadOnly ? '30' : '30'" class="options">
        <div *ngIf="reviewState != reviewStates.ReadOnly">
          <mat-radio-group formControlName="wireInternational" id="wireInternational" class="profile-radio-group">
            <mat-radio-button id="wireInternationalYes" [value]="true">Yes</mat-radio-button>
            <mat-radio-button id="wireInternationalNo" [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
          <mat-label class="read-only-label">{{getFormControlValue('wireInternational') ? 'Yes' : 'No'}}</mat-label>
        </div>
      </div>
    </div>

    <div [hidden]="!getFormControlValue('wireInternational')" fxLayout="row" fxLayout.xs="column" class="section">
      <div [fxFlex]='100'>
        <div class="bottom-separation">
          <mat-form-field appearance="outline">
            <mat-label>International Countries</mat-label>
            <mat-chip-list id="internationalCountry" #chipList
                  aria-label="Selected Countries"
                  formControlName="internationalCountry"
                  [disabled]="reviewState === reviewStates.ReadOnly"
                  >
            <mat-chip
                *ngFor="let country of getSelectedCountryList()"
                [removable]="removable"
                [disabled]="reviewState === reviewStates.ReadOnly"
                (removed)="remove(country.countryId)"
                (keydown)="onChipKeydown($event, country.countryId)"
                (click)="remove(country.countryId)"
              >
                {{country.countryName}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
              <input *ngIf="reviewState !== reviewStates.ReadOnly" id="internationalCountryInput"
                     #countryInput
                     id="internationalCountryInput"
                     placeholder="Add Country..."
                     formControlName="countryInput"
                     [matAutocomplete]="auto"
                     [matChipInputFor]="chipList"
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     (matChipInputTokenEnd)="tokenAdded($event)"
                     (keydown)="onInputKeydown($event)"
                     aria-describedby="mat-hint-0"
                     aria-controls="tcb-autocomplete-list"
                     >
            </mat-chip-list>
            <mat-autocomplete #auto="matAutocomplete" id="internationalCountryAutocomplete"
                              (optionSelected)="selected($event)" role="listbox">
              <mat-option *ngFor="let country of filteredCountries | async" [value]="country">
                {{country.countryName}}
              </mat-option>
            </mat-autocomplete>
            <mat-hint>
              You may select up to 5 countries.
            </mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div fxLayout="row" fxLayout.xs="column" class="section">
      <div [fxFlex]="70">
        <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Will you be conducting cash transactions?</div>
      </div>

      <div [fxFlex]="30" class="options">
        <div *ngIf="reviewState != reviewStates.ReadOnly">
          <mat-radio-group formControlName="cashTransactions" id="cashTransactions" class="profile-radio-group">
            <mat-radio-button id="cashTransactionsYes" [value]="true">Yes</mat-radio-button>
            <mat-radio-button id="cashTransactionsNo" [value]="false">No</mat-radio-button>
          </mat-radio-group>
        </div>
        <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
          <mat-label class="read-only-label">{{getFormControlValue('cashTransactions') ? 'Yes' : 'No'}}</mat-label>
        </div>
      </div>
    </div>

    <div fxLayout="column" fxLayout.xs="column" class="section">
      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]="70">
          <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Will you utilize a debit card?</div>
        </div>

        <div [fxFlex]="30" class="options">
          <div *ngIf="reviewState != reviewStates.ReadOnly">
            <mat-radio-group formControlName="useDebitCard" id="useDebitCard" class="profile-radio-group">
              <mat-radio-button id="useDebitCardYes" [value]="true">Yes</mat-radio-button>
              <mat-radio-button id="useDebitCardNo" [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
            <mat-label class="read-only-label">{{getFormControlValue('useDebitCard') ? 'Yes' : 'No'}}</mat-label>
          </div>
        </div>
      </div>   

      <div *ngIf="(canViewOrderOptions)&&(isOrderDebit?.toLowerCase() === 'true')">
        <div  [hidden]="!(showOrderDebitCard$ | async)" class="sub-section">
          <div fxLayout="row" fxLayout.xs="column" class="sub-option">
            <div [fxFlex]="70" fxLayoutAlign="start center">
              <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Would you like to order a debit card?</div>
            </div>

            <div [fxFlex]="30">
              <div *ngIf="reviewState != reviewStates.ReadOnly">
                <mat-radio-group formControlName="orderDebitCard" id="orderDebitCard" class="profile-radio-group">
                  <mat-radio-button id="orderDebitCardYes" [value]="true">Yes</mat-radio-button>
                  <mat-radio-button id="orderDebitCardNo" [value]="false">No</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="read-only-label sub-section-read-only" *ngIf="reviewState === reviewStates.ReadOnly">
                <mat-label class="read-only-label">{{getFormControlValue('orderDebitCard') ? 'Yes' : 'No'}}</mat-label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div fxLayout="column" class="section">
      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]="70" fxLayoutAlign="start center">
          <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Will you utilize checks?</div>
        </div>

        <div [fxFlex]="30" class="options">
          <div *ngIf="reviewState != reviewStates.ReadOnly">
            <mat-radio-group formControlName="useChecks" id="useChecks" class="profile-radio-group">
              <mat-radio-button id="useChecksYes" [value]="true">Yes</mat-radio-button>
              <mat-radio-button id="useChecksNo" [value]="false">No</mat-radio-button>
            </mat-radio-group>
          </div>
          <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
            <mat-label class="read-only-label">{{getFormControlValue('useChecks') ? 'Yes' : 'No'}}</mat-label>
          </div>
        </div>
      </div>
      <div  *ngIf="(isOrderChecks?.toLowerCase() === 'true')&&(canViewOrderOptions)" >
        <div  [hidden]="!(showOrderChecks$ | async)" class="sub-section">
          <div fxLayout="row" fxLayout.xs="column" class="sub-option">
            <div [fxFlex]="70" fxLayoutAlign="start center">
              <div>{{(reviewState !== reviewStates.ReadOnly)? '* ': ''}}Would you like to order checks?</div>
            </div>

            <div [fxFlex]="30">
              <div *ngIf="reviewState != reviewStates.ReadOnly">
                <mat-radio-group formControlName="orderChecks" id="orderChecks" class="profile-radio-group">
                  <mat-radio-button id="orderChecksYes" [value]="true">Yes</mat-radio-button>
                  <mat-radio-button id="orderChecksNo" [value]="false">No</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="read-only-label" *ngIf="reviewState === reviewStates.ReadOnly">
                <mat-label class="read-only-label sub-section-read-only">{{getFormControlValue('orderChecks') ? 'Yes' : 'No'}}</mat-label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </fieldset>
</form>
